import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { ProductCardSkeleton } from '@/domains/core/tamagoshi/ProductCardSkeleton/ProductCardSkeleton';

import styles from './playlistGraphQLSkeleton.module.scss';

interface Props {
  cardsNumber: number;
  className?: string;
  title?: React.ReactNode;
}

export const PlaylistGraphQLSkeleton: FunctionComponent<Props> = ({
  cardsNumber,
  className,
  title,
}) => {
  return (
    <div
      className={classnames(styles.carousel, className)}
      data-testid="playlist-skeleton"
    >
      {title}
      <div className={styles.slider}>
        {[...Array(cardsNumber)].map((_, index) => (
          <ProductCardSkeleton
            key={`product-card-skel-${index}`}
            style={{ height: '312px' }}
            vertical
          />
        ))}
      </div>
    </div>
  );
};
